import { EllipsedText, Loading, MaterialIcon, VirtualizedComponent } from '@gorila-shared-ui/components';
import { ListItem, ListItemLabel } from 'baseui/list';
import { CSSProperties, memo, useRef } from 'react';
import { ListChildComponentProps } from 'react-window';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useHover } from 'usehooks-ts';
import { useStyles } from '../../hooks/useStyles';
import { deliveryFenceState, selectedDeliveryFenceIdState } from '../../storage/deliveryFences';
import { StyledTooltip } from '../ui/StyledTooltip';

function DeliveryFenceItem({ data, index, style }: Readonly<ListChildComponentProps<VirtualizedComponent['data']>>) {
  const { classes, concatenateClasses, css, theme, overrides } = useStyles();
  const [selectedDeliveryFenceId, setSelectedDeliveryFenceId] = useRecoilState(selectedDeliveryFenceIdState);
  const deliveryFenceId = data.items[index];
  const deliveryFence = useRecoilValue(deliveryFenceState(deliveryFenceId));
  const hoverRef = useRef(null);
  const isHover = useHover(hoverRef);

  const isSelected = selectedDeliveryFenceId === deliveryFenceId;

  const onSelectDeliveryFence = () => {
    if (selectedDeliveryFenceId === deliveryFenceId) setSelectedDeliveryFenceId(undefined);
    else setSelectedDeliveryFenceId(deliveryFenceId);
  };

  return (
    <span
      style={style as CSSProperties}
      ref={hoverRef}
    >
      {data.isLoaded(index) ? (
        <ListItem
          overrides={overrides.listItemOverrides({
            onClick: onSelectDeliveryFence,
            isHover,
            isSelected,
          })}
        >
          <ListItemLabel>
            <span
              className={concatenateClasses(
                classes.horizontalFlex,
                classes.centeredStart,
                css({ gap: theme.sizing.scale500 }),
              )}
            >
              <StyledTooltip
                content={deliveryFence?.active ? 'Activo' : 'Inactivo'}
                showArrow={false}
              >
                <MaterialIcon
                  name="pin_drop"
                  color={deliveryFence?.active ? theme.colors.contentPositive : theme.colors.contentStateDisabled}
                />
              </StyledTooltip>
              <EllipsedText
                inline
                breakAll
              >
                {deliveryFence?.name || '-'}
              </EllipsedText>
            </span>
          </ListItemLabel>
        </ListItem>
      ) : (
        <Loading size="compact" />
      )}
    </span>
  );
}

export default memo(DeliveryFenceItem);
